export default "__VITE_ASSET__dd4efe3e__"